function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b3be2aa3-fa70-4234-bfaa-5f9b8ccf34d2{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "be2b9a9c-a8dd-48a0-93a9-6e8c2815cfee",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "e3b5a036-7807-4942-939d-861612c5b1af",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "a528f3f6-57cd-4713-a080-da759a96a31a",
  "data-name": "Path 70",
  className: "b3be2aa3-fa70-4234-bfaa-5f9b8ccf34d2",
  d: "M7.8,6C6.8,6,6,6.6,6,7.2V129.4c0,.7.8,1.2,1.8,1.2H68.6c1,0,1.7.5,1.8,1.2s.1,1.2.1,1.8c0,26.5-25.2,48.8-59.6,55.6-.8.2-1.3.6-1.3,1.2v53.8c0,.7.8,1.2,1.7,1.2h0c91.3,0,165.8-50.8,170.4-114.8h.2V7.2c0-.7-.8-1.2-1.8-1.2Z"
})));

var SvgLogoIcon8 = function SvgLogoIcon8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 187.9 251.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (8).78e2be84.svg";
export { ForwardRef as ReactComponent };